import { useEffect } from 'react';

export const useEffectOnMount = (fn: Parameters<typeof useEffect>[0]) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fn, []);
};
